<div class="item-sets-panel">
  <div *ngIf="loading" class="loading-state">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="error" class="error-state">
    <p-message severity="error" [text]="error"></p-message>
    <button pButton type="button" label="Retry" icon="pi pi-refresh" (click)="refresh()" styleClass="p-button-sm"></button>
  </div>

  <div *ngIf="!loading && !error" class="content">
  <div *ngIf="!selectedItemSet" class="sets-list">
    <!-- Action Buttons Section -->
    <div class="action-section">
      <h3>Item Sets</h3>
      <div class="action-buttons">
        <button pButton type="button" 
                label="New Set" 
                icon="pi pi-plus"
                styleClass="p-button-sm"
                class="p-button-success" 
                (click)="createNewSet()">
        </button>
        <button pButton type="button" 
                label="Add to Set" 
                icon="pi pi-arrow-down"
                styleClass="p-button-sm"
                class="p-button-info" 
                (click)="addToExistingSet()">
        </button>
      </div>
    </div>

    <!-- Search and Filters Section -->
    <div class="filters-section">
      <div class="search-container" #searchContainer>
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input type="text" 
                 pInputText 
                 placeholder="Search by name or ID" 
                 [(ngModel)]="searchTerm"
                 (input)="onSearchChange()"
                 class="search-input">
        </span>
        <div class="resize-handle" 
             (mousedown)="startResize($event)"
             title="Drag to resize search bar"></div>
      </div>
      
      <div class="sort-buttons">
        <button pButton type="button" 
                [label]="'Alphabetical ' + (sortBy === 'alphabetical' ? (sortDirection === 'asc' ? '↑' : '↓') : '')" 
                [icon]="sortBy === 'alphabetical' ? (sortDirection === 'asc' ? 'pi pi-align-left' : 'pi pi-align-right') : 'pi pi-align-left'"
                styleClass="p-button-sm"
                [class]="sortBy === 'alphabetical' ? 'p-button-secondary' : 'p-button-outlined'" 
                (click)="onSortChange('alphabetical')">
        </button>
        <button pButton type="button" 
                [label]="'Size ' + (sortBy === 'size' ? (sortDirection === 'asc' ? '↑' : '↓') : '')" 
                [icon]="sortBy === 'size' ? (sortDirection === 'asc' ? 'pi pi-arrow-up' : 'pi pi-arrow-down') : 'pi pi-bars'"
                styleClass="p-button-sm"
                [class]="sortBy === 'size' ? 'p-button-secondary' : 'p-button-outlined'" 
                (click)="onSortChange('size')">
        </button>
      </div>
    </div>

    <!-- Sets List Section -->
    <div class="section">
      <div class="sets-grid">
        <div *ngFor="let set of filteredSets" class="set-item">
          <!-- Main row with all controls in one line -->
          <div class="set-main-row">
            <!-- Left: Name and ID (clickable) -->
            <div class="set-info" 
                 (click)="toggleThumbnails(set)"
                 [class.clickable]="!isSetEmpty(set)"
                 [class.loading]="isLoadingThumbnails(set)"
                 [class.expanded]="set.thumbnailsExpanded"
                 [pTooltip]="getTooltipText(set)"
                 [tooltipDisabled]="isSetEmpty(set)"
                 tooltipPosition="top">
              <div class="set-name-container">
                <i class="dropdown-arrow pi" 
                   [class.pi-angle-right]="!set.thumbnailsExpanded && !isLoadingThumbnails(set)"
                   [class.pi-angle-down]="set.thumbnailsExpanded && !isLoadingThumbnails(set)"
                   [class.pi-spin]="isLoadingThumbnails(set)"
                   [class.pi-spinner]="isLoadingThumbnails(set)"
                   [class.hidden]="isSetEmpty(set)"></i>
                <span class="set-name">{{ set.name }}</span>
                <span class="set-id-badge">{{ set.id }}</span>
              </div>
              <span class="set-item-count">({{ set.itemCount || 0 }})</span>
            </div>
            
            <!-- Right: View button (simplified) -->
            <div class="set-actions">
              <span class="view-link" (click)="selectItemSet(set)">View</span>
            </div>
          </div>

          <!-- Expandable content area -->
          <div class="set-expandable" *ngIf="shouldShowExpandedContent(set)">
            <!-- Loading state -->
            <div class="set-preview-loading" *ngIf="isLoadingThumbnails(set)">
              <div class="preview-placeholder" *ngFor="let i of [1,2,3]; let idx = index" 
                   [style.animation-delay]="(idx * 0.2) + 's'">
                <i class="pi pi-image"></i>
              </div>
              <div class="loading-text">
                <span>Loading images...</span>
              </div>
            </div>

            <!-- Thumbnails when loaded - CAROUSEL VERSION -->
            <div class="set-preview-container" *ngIf="hasThumbnailsExpanded(set) && getSetPreviewThumbnails(set).length > 0">
              <!-- Carousel navigation -->
              <div class="carousel-header">
                <div class="carousel-controls">
                  <button class="carousel-btn carousel-btn-left" 
                          (click)="goToPreviousPage(set)"
                          [disabled]="!canGoPrevious(set)">
                    <i class="pi pi-angle-left"></i>
                  </button>
                  <span class="page-info" *ngIf="getTotalPages(set) > 1">{{ getPageInfo(set) }}</span>
                  <button class="carousel-btn carousel-btn-right" 
                          (click)="goToNextPage(set)"
                          [disabled]="!canGoNext(set)">
                    <i class="pi pi-angle-right"></i>
                  </button>
                </div>
              </div>
              
              <!-- Thumbnail carousel - showing exactly 5 images -->
              <div class="set-preview-fixed">
                <img *ngFor="let item of getCurrentPageThumbnails(set); let i = index" 
                     [src]="getThumbnailUrl(item)" 
                     [alt]="item.name" 
                     class="preview-thumbnail clickable-thumbnail"
                     [style.animation-delay]="(i * 0.1) + 's'"
                     (load)="onImageLoad($event)"
                     (error)="onImageError($event)"
                     (click)="navigateToItemFromThumbnail(item, $event)"
                     [title]="'Click to view ' + item.name">
              </div>
              
              <!-- Progress indicator -->
              <div class="carousel-progress" *ngIf="getTotalPages(set) > 1">
                <div class="progress-dots">
                  <span class="progress-text">Page {{ (set.currentPage || 0) + 1 }} of {{ getTotalPages(set) }}</span>
                </div>
              </div>
            </div>
            
            <!-- Items without images section - Only show if there are also images to display -->
            <div class="set-preview-missing" *ngIf="hasItemsWithoutThumbnails(set) && getSetPreviewThumbnails(set).length > 0">
              <div class="missing-images-container">
                <div class="missing-header">
                  <i class="pi pi-image"></i>
                  <span class="missing-count">{{ getItemsWithoutThumbnails(set).length }} items without images</span>
                </div>
              </div>
            </div>
            
            <!-- No images available message - Only when expanded and no images at all -->
            <div class="set-preview-no-images" *ngIf="hasThumbnailsExpanded(set) && getSetPreviewThumbnails(set).length === 0 && !isSetEmpty(set)">
              <div class="no-images-placeholder">
                <i class="pi pi-image"></i>
                <span class="no-images-message">No images available</span>
              </div>
            </div>
            
            <!-- Empty set message -->
            <div class="set-preview-empty" *ngIf="isSetEmpty(set) && set.thumbnailsExpanded">
              <div class="empty-placeholder empty-set">
                <i class="pi pi-inbox"></i>
                <span class="empty-message">Empty set</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Vista detallada de un set -->
  <div *ngIf="selectedItemSet" class="set-detail">
    <div class="set-header">
      <div class="header-top">
        <button pButton type="button" 
                icon="pi pi-arrow-left" 
                label="Back to List"
                styleClass="p-button-sm"
                class="p-button-text" 
                (click)="backToList()">
        </button>
        <h2>
          {{ selectedItemSet.name }} 
          (<a [href]="'/item-sets/' + selectedItemSet.id" target="_blank" class="id-link">{{ selectedItemSet.id }}</a>)
        </h2>
      </div>
      
      <div class="header-actions">
        <button pButton type="button" 
                label="Add Selected Items" 
                icon="pi pi-plus"
                styleClass="p-button-sm"
                class="p-button-success" 
                (click)="addSelectedFromMain()">
        </button>
      </div>
    </div>

    <div class="table-actions" *ngIf="selectedItems.length > 0">
      <div class="selected-count">
        {{ selectedItems.length }} items selected
      </div>
      <div class="action-buttons">
        <button pButton type="button" 
                label="Move Selected" 
                icon="pi pi-arrow-right"
                styleClass="p-button-sm"
                class="p-button-warning" 
                (click)="moveSelectedItems()">
        </button>
        <button pButton type="button" 
                label="Copy Selected" 
                icon="pi pi-copy"
                styleClass="p-button-sm"
                class="p-button-info" 
                (click)="copySelectedItems()">
        </button>
        <button pButton type="button" 
                label="Remove Selected" 
                icon="pi pi-trash"
                styleClass="p-button-sm"
                class="p-button-danger" 
                (click)="deleteSelectedItems()">
        </button>
      </div>
    </div>

      <p-table [value]="selectedItemSet.items_ref" 
                [(selection)]="selectedItems"
                [scrollable]="true" 
                scrollHeight="calc(100vh - 250px)"
                selectionMode="multiple"
                dataKey="id"
                styleClass="flex-auto">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>ID</th>
            <th>Name</th>
            <th>Thumbnail</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <p-tableCheckbox [value]="item"></p-tableCheckbox>
            </td>
            <td>{{ item.id }}</td>
            <td>
              <a href="javascript:void(0)" 
                 (click)="navigateToItem(item)" 
                 class="item-name-link"
                 [title]="'Click to view ' + item.name">
                {{ item.name }}
              </a>
            </td>
            <td>
              <img [src]="getThumbnailUrl(item)" 
                    [alt]="item.name" 
                    width="60" 
                    class="thumbnail-image rounded border clickable-thumbnail"
                    *ngIf="getThumbnailUrl(item)"
                    (click)="navigateToItem(item)"
                    [title]="'Click to view ' + item.name"/>
              <span *ngIf="!getThumbnailUrl(item)">No image</span>
            </td>
            <td>
              <button pButton type="button" 
                      icon="pi pi-trash" 
                      class="p-button-danger p-button-text"
                      (click)="removeItem(item)">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
  </div>
</div>
